import React, { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "../../../Components";
import { useSelector, useDispatch } from "react-redux";
import { ButtonBase } from "@material-ui/core";
import { useTitle } from "../../../Hooks";
import { GlobalOrderFilterActions } from "../../../store/GlobalOrderFilter/GlobalOrderFilterActions";
import { GlobalAdvanceSearchActions } from "../../../store/GlobalAdvanceSearch/GlobalAdvanceSearchActions";
import { ViewTypesEnum } from "../../../Enums";
import { PaginationComponent } from "../../../Components/PaginationComponent/PaginationComponent";
import {
  bottomBoxComponentUpdate,
  sideMenuIsOpenUpdate,
  sideMenuComponentUpdate,
  showError,
  returnPropsByPermissions 
} from "../../../Helper";
import { GetFilteredVendorClientTrackingsAPI } from "../../../Services";
import { ClientsTrackingTableComponent } from "./ClientsTrackingUtilities/Sections";
import ExportButton from "../VendorsView/VendorsTabsSections/Offers/components/ExportButton";
import { ClientsTrackingPermissions  } from "../../../Permissions";

const parentTranslationPath = "ClientsTracking";
const translationPath = "";

export const ClientTrackingView = () => {
  const { t } = useTranslation(parentTranslationPath);
  useTitle(t(`${translationPath}clients-tracking`));
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const [isClearFiltersClicked, setIsClearFiltersClicked] = useState(false);
  const dateRangeDefault = {
    startDate: null,
    endDate: null,
    key: "selection",
    selectedDateType: 1,
  };

  const [sortBy, setSortBy] = useState(null);
  const [activeItem, setActiveItem] = useState(null);
  const [detailsClientTrackingList, setDetailsClientTrackingList] = useState({
    result: [],
    totalCount: 0,
  });
  const [defaultfilter, setDefaultFilter] = useState({
    pageIndex: 0,
    pageSize: parseInt(localStorage.getItem("Pagination")) || 25,
    vendorClientTrackingId: null,
    vendorOfferId: null,
    vendorOfferName: null,
    vendorId: null,
    vendorName: null,
    contactId: null,
    contactName: null,
    serviceId: null,
    serviceName: null,
    psiCommissionStatusId: null,
    psiCommissionStatusName: null,
    qrCode: null,
    promoCode: null,
    discountPercentage: null,
    psiCommissionPercentage: null,
    invoiceId: null,
    transactionStatusId: null,
    transactionStatusName: null,
    clientFeedback: null,
    transactionAmount: null,
    vendorServiceCategoryId: null,
    vendorServiceCategoryName: null,
    createdOn: null,
    createdBy: null,
    searchType: null,
    filterBy: null,
    orderBy: 1,
  });

  const [filter, setFilter] = useState(defaultfilter);
  const [isFirst, setIsFirst] = useState(false);

  const [clientTrackingTableFilter, setClientTrackingTableFilter] =
    useState(null);

  // const filterByChanged = (value) => {
  //   setSelectedOrderBy((item) => ({ ...item, filterBy: value }));
  //     setSortBy((item) => ({
  //       ...item,
  //       filterBy: value,
  //     })) ;

  // };
  // const orderByChanged = (value) => {
  //   setSelectedOrderBy((item) => ({ ...item, orderBy: value }));
  //   setSortBy((item) => ({
  //     ...item,
  //     orderBy: value,
  //   })) ;
  // };
  // const orderBySubmitted = (event) => {
  //   event.preventDefault();
  //   if (!selectedOrderBy.filterBy || !selectedOrderBy.orderBy) {
  //     if (orderBy.filterBy || orderBy.orderBy) setOrderBy({});
  //     return;
  //   }
  //   dispatch(
  //     GlobalOrderFilterActions.globalOrderFilterRequest({
  //       ...orderFilter,
  //       ClientsTrackigFilter: {
  //         ...orderFilter.VendorsFilter,
  //         filterBy: selectedOrderBy.filterBy,
  //         orderBy: selectedOrderBy.orderBy,
  //       },
  //     })
  //   );
  //   setOrderBy({
  //     filterBy: selectedOrderBy.filterBy,
  //     orderBy: selectedOrderBy.orderBy,
  //   });
  // };

  const onClearedAllFiltersClick = useCallback(() => {
    setIsClearFiltersClicked(isClearFiltersClicked ? false : true);
    setFilter({ ...defaultfilter });
    setClientTrackingTableFilter(null);
  }, []);

  const GetAllClientsTracking = useCallback(async () => {
    if(returnPropsByPermissions(ClientsTrackingPermissions.ViewClientTracking.permissionsId)){
    setIsLoading(true);
    if (!isFirst) setIsFirst(true);
    if (isLoading) return;

    try {
      const res = await GetFilteredVendorClientTrackingsAPI({
        ...filter,
        pageSize: filter.pageSize,
        pageIndex: filter.pageIndex + 1,
        filterBy:
          (sortBy?.filterBy &&
            sortBy.filterBy[0].toLowerCase() + sortBy.filterBy.slice(1)) ||
          filter?.filterBy ||
          "CreatedOn",
        orderBy: sortBy?.orderBy || filter?.orderBy || 2,
      });
      if (res && res.result) {
        setDetailsClientTrackingList({
          result: res.result,
          totalCount: res.totalCount,
        });
      }
    } catch (error) {
      showError(t`something_went_wrong`);
      setDetailsClientTrackingList({
        result: [],
        totalCount: 0,
      });
    } finally {
      setIsLoading(false);
    }
  }
  }, [filter, sortBy, isLoading]);

  const reloadData = useCallback(() => {
    setFilter((item) => ({ ...item, pageIndex: 0 }));
  }, []);

  useEffect(() => {
    GetAllClientsTracking();
  }, [filter, sortBy]);

  useEffect(
    () => () => {
      bottomBoxComponentUpdate(null);
      sideMenuComponentUpdate(null);
      sideMenuIsOpenUpdate(false);
    },
    []
  );

  return (
    <div className="d-flex-column">
      <div className="header-section">
        <div className="filter-section">
          <div className="section">
            {/* <ButtonBase
              className="btns theme-solid"
              idRef="addNewClientTrackingRef"
              id="add-new-client-tracking"
              onClick={() => {}}
            >
              <span>{t(`${translationPath}add-new-client-tracking`)}</span>
            </ButtonBase> */}
          </div>
          <div className="section autocomplete-section"></div>
        </div>
        <div className="">
          {/* <span className="mx-2 mt-1">
            {t(`${translationPath}clients-tracking`)}
          </span> */}
          <span className="separator-v s-primary s-reverse s-h-25px mt-1" />
          <span className="px-2 d-flex">
            {/* <span className="texts-large mt-1">
              {t(`${translationPath}order-by`)}:
            </span> */}
            {/* <div className="px-2">
              <SelectComponet
                idRef="select-filter-byfilterByRef"
                data={[{ id: "CreatedOn", filterBy: "created-on" }]}
                value={selectedOrderBy?.filterBy}
                onSelectChanged={filterByChanged}
                wrapperClasses="mb-3"
                isRequired
                valueInput="id"
                textInput="filterBy"
                emptyItem={{
                  value: null,
                  text: "select-filter-by",
                  isDisabled: false,
                }}
                parentTranslationPath={parentTranslationPath}
                translationPath={translationPath}
                translationPathForData={translationPath}
              />
            </div> */}
            {/* <div className="px-2">
              <SelectComponet
                idRef="orderByRef"
                data={[
                  { id: 1, orderBy: "ascending" },
                  { id: 2, orderBy: "descending" },
                ]}
                 value={selectedOrderBy?.orderBy}
                 onSelectChanged={orderByChanged}
                wrapperClasses="mb-3"
                isRequired
                valueInput="id"
                textInput="orderBy"
                emptyItem={{
                  value: null,
                  text: "select-sort-by",
                  isDisabled: false,
                }}
                parentTranslationPath={parentTranslationPath}
                translationPath={translationPath}
                translationPathForData={translationPath}
              />
            </div> */}
            {/* <div className="mt-1">
              <ButtonBase
                className="btns theme-solid"
                id="action_apply"
                onClick={orderBySubmitted}
                disabled={!selectedOrderBy?.filterBy || !selectedOrderBy?.orderBy}
              >
                <span>{t(`${translationPath}apply`)}</span>
              </ButtonBase>
            </div> */}
          </span>
          <div className="d-flex d-inline d-flex-v-center-h-between">
            <span />

            <div className="mt-1  mb-2">
              <div className="px-2 mt-2 mb-2">
                <ExportButton
                  filter={{
                    ...filter,
                    pageSize: detailsClientTrackingList?.totalCount,
                    pageIndex: 1,
                    isClientTracking : true,
                    totalCount :  detailsClientTrackingList?.totalCount,
                  }}
                />
              </div>

              <ButtonBase
                className="btns theme-solid bg-danger clear-all-btn"
                id="action_apply"
                onClick={onClearedAllFiltersClick}
              >
                <span className="mdi mdi-filter-remove m-1" />
                {t(`${translationPath}clear-filters`)}
              </ButtonBase>
            </div>
          </div>
        </div>
      </div>

      <div className="view-wrapper client-tracking-view">
        <Spinner isActive={isLoading} isAbsolute />
        <ClientsTrackingTableComponent
          translationPath={translationPath}
          parentTranslationPath={parentTranslationPath}
          detailsClientTrackingList={detailsClientTrackingList}
          filter={filter}
          setFilter={setFilter}
          setSortBy={setSortBy}
          sortBy={sortBy}
          reloadData={reloadData}
          setClientTrackingTableFilter={setClientTrackingTableFilter}
          clientTrackingTableFilter={clientTrackingTableFilter}
          isClearFiltersClicked={isClearFiltersClicked}
          setIsClearFiltersClicked={setIsClearFiltersClicked}
          isFirst={isFirst}
        />
      </div>
    </div>
  );
};
